import { createFileRoute } from '@tanstack/react-router'
import { PresentationView } from '@/features/tracker/PresentationView'

function Present() {
  const { companyId, asUser } = Route.useSearch()
  return <PresentationView companyId={companyId} asUser={asUser} />
}

export const Route = createFileRoute('/tracker/present')({
  // companyId: staff arrive here from a specific ticket's row on the tracker
  // list, which already knows that ticket's companyId (see TrackerListView's
  // Present button) — an admin request without it 400s server-side
  // (getTrackerPresentation requires companyId for an unlensed admin).
  // Not required at all while lensed: the server resolves the lensed user's
  // own company and ignores companyId, same as every other tracker route.
  validateSearch: (raw: Record<string, unknown>): { companyId?: string; asUser?: string } => ({
    companyId: typeof raw.companyId === 'string' && raw.companyId ? raw.companyId : undefined,
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
  }),
  component: Present,
})
